import { Colors } from "@blueprintjs/core";
import { useLocation } from "react-router";

import { isCoach } from "@/components/helpers/workspace/permissions";
import { Box, Flex } from "@/components/layout/flexbox";
import { Media } from "@/components/layout/Media";
import { SectionContainer } from "@/components/pages_logged_in/workspace/messages/SectionContainer";
import { BackLink } from "@/components/pieces/BackLink";
import { Avatar } from "@/components/pieces/users/Avatar";
import { STANDARD_NAV_HEIGHT } from "@/css/constants";
import { useChatCustomerQuery } from "@/graphql";

import { DirectMessageList } from "./DirectMessageList";
import { MeetingList } from "./MeetingList";
import { ReviewList } from "./ReviewList";

interface ClientChannelListProps {
  customerId: string;
  onMessageRead: () => void;
}

export function ClientChannelList({
  customerId,
  onMessageRead = () => null,
}: ClientChannelListProps) {
  const { data } = useChatCustomerQuery({
    variables: { customerId },
    onCompleted: () => {},
  });

  const location = useLocation();
  const { customer } = data ?? {};
  const isCoachUser = isCoach();
  const isClientPage = !isCoachUser || location.pathname.startsWith("/client");
  const widthAtLarge = isClientPage ? 550 : 400;

  return (
    <SectionContainer
      header={
        <Flex
          height={STANDARD_NAV_HEIGHT}
          alignItems="center"
          style={{ backgroundColor: Colors.WHITE }}
          className="bbs brs"
          justifyContent="space-between"
        >
          {isCoachUser && !isClientPage ? (
            <Media lessThan="xl">
              <Box>
                <BackLink to="/messages" label="Messages" />
              </Box>
            </Media>
          ) : null}
          <Box>
            <Media lessThan="md">
              <Flex alignItems="center" ml={2} mr={1}>
                {customer?.name ? <Avatar user={customer} /> : null}
                <Box ml={2}>{customer?.name}'s Channels</Box>
              </Flex>
            </Media>
            <Media greaterThanOrEqual="md">
              <Box ml={3}>Channels</Box>
            </Media>
          </Box>
        </Flex>
      }
      headerHeight={STANDARD_NAV_HEIGHT}
      width={[1, 275, widthAtLarge - 20, widthAtLarge]}
    >
      <Box pb={5}>
        <DirectMessageList
          customerId={customerId}
          onMessageRead={onMessageRead}
        />
        <MeetingList customerId={customerId} onMessageRead={onMessageRead} />
        <ReviewList customerId={customerId} onMessageRead={onMessageRead} />
      </Box>
    </SectionContainer>
  );
}
